export function getCurrencyByCountryId(id) {
  const mapping = {
    1: "eur", // Ελλάδα
    2: "usd", // USA
    3: "eur", // Ιταλία
    4: "eur", // Ισπανία
    5: "try", // Τουρκία
    6: "inr", // Ινδία
    7: "mxn", // Μεξικό
    8: "cny", // Κίνα
    9: "eur", // Γαλλία
    10: "thb", // Ταϊλάνδη
    // ... συμπλήρωσε κι άλλα αν έχεις
  };
  return mapping[id] || "eur"; // default EUR
}

// **ΠΡΟΣΘΕΣΕ αυτό**
export function getCurrencySymbol(currency) {
  switch (currency) {
    case "usd":
      return "$";
    case "eur":
      return "€";
    case "try":
      return "₺";
    case "inr":
      return "₹";
    case "mxn":
      return "$";
    case "cny":
      return "¥";
    case "thb":
      return "฿";
    // ... βάλε ό,τι άλλο έχεις
    default:
      return "€";
  }
}
